import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
// import ListItem from "@mui/material/ListItem";
import MuiListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { menu as AdminMenuData } from "./AdminMenuData";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { ListItemButton, Menu } from '@mui/material';
import { useMenu, useAppDispatch, useAppSelector } from 'src/hooks';
import GenerateIcon from '../global/GenerateIcon';
import MenuLoadingSkeleton from '../skeletons/MenuLoadingSkeleton';
import './index.scss';

// import { hasChildren } from "../../utils/hasChildren";
const _ = require('lodash');

const StyledList = styled(List)`
  background-color: #000;
`;

const StyledListItemIcon = styled(ListItemIcon)(({ theme, iconVisible }) => ({
  color: theme.palette.primary.textColor,
  visibility: iconVisible == true ? 'visible' : 'hidden'
}));

const StyledRouterLink = styled(RouterLink)`
  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.primary.sideMenuTextColor};
  font-size: 14px;
  font-color: ${({ theme }) => theme.palette.primary.sideMenuTextColor};
  font-weight: 500;
  text-decoration: none;
`;

const CollapsibleStyle = {
  background: 'transparent',
  margin: '0',
  overflow: 'hidden'
};

const urlMap = (currItem) => {
  const currPath = location.pathname;
  const splittedPath = currPath.split('/');

  const isMatched = splittedPath.filter((e) => e === currItem);

  return isMatched.length > 0;
};

const ListItem = withStyles({
  root: {
    color: '#8F8F8F',
    '&$selected': {
      backgroundColor: '#00000014',
      color: '#0000A0',
      borderLeft: '5px solid #0000A0',
      fontWeight: '500'
    },
    '&:hover': {
      backgroundColor: '#00000014',
      color: '#0000A0',
      '& .MuiListItemIcon-root': {
        color: '#8F8F8F'
      }
    }
  },
  selected: {}
})(MuiListItem);

function CollapsibleMenu({ variant, data, isOpenClicked, isSidebarOpenState }) {
  const [openedCollapseMenuIndex, setOpenedCollapseMenuIndex] = useState();
  const [openedMenuIndex, setOpenedMenuIndex] = useState();

  useEffect(() => {
    if (!isOpenClicked) {
      setOpenedMenuIndex(openedCollapseMenuIndex);
      setOpenedCollapseMenuIndex(null);
    } else {
      setOpenedCollapseMenuIndex(openedMenuIndex);
    }
  }, [isOpenClicked]);

  const handleCollapseMenuClick = (index) => {
    if (index === openedCollapseMenuIndex) {
      setOpenedCollapseMenuIndex(null);
    } else {
      setOpenedCollapseMenuIndex(index);
    }
  };

  if (data === null)
    return (
      <MenuLoadingSkeleton
        variant='rectangular'
        marginx={1}
        marginy={1}
        count={5}
        height={48}
      />
    );

  if (_.isEmpty(data) != true) {
    // console.log("this is data within collapsible menu📋", data)
    return data.map((menu, parentIndex) => {
      // console.log("this is menuItem parent 🧔🏻", menu)

      let menuItem = null;
      if (menu?.level == 0) {
        menuItem = menu.pages;
        // console.log("this is menuItem combined pagelist 🧔🏻", menuItem)
        return menuItem.map((item) => (
          <CustomMenuItem
            key={`${menu.id}-${menu.slug}-${item.id}`}
            item={item}
            variant={variant}
            icon
            handleCollapseMenuClick={handleCollapseMenuClick}
            parentIndex={parentIndex}
            openedCollapseMenuIndex={openedCollapseMenuIndex}
            sideBarState={isSidebarOpenState}
            // handleClick={handleClick}
          />
        ));
      }
      if (menu?.parent.name == 'Default' && menu?.level == 1 && menu.visible) {
        const menuItem = menu;
        // console.log("this is menuItem combined pagelist 🤓🧔🏻", menuItem)
        return (
          <CustomMenuItem
            key={`${menu.id}-${menuItem.id}-${menuItem.id}`}
            item={menuItem}
            variant={variant}
            icon
            handleCollapseMenuClick={handleCollapseMenuClick}
            parentIndex={parentIndex}
            openedCollapseMenuIndex={openedCollapseMenuIndex}
            sideBarState={isSidebarOpenState}
          />
        );
      }
      if (menu?.level > 1 && menu?.level <= 2 && menu.children) {
        const menuItem = menu;
        // console.log("this is menuItem combined pagelist 🤓🧔🏻", menuItem)
        return (
          <CustomMenuItem
            key={`${menu.id}-${menuItem.id}-${menuItem.id}`}
            item={menuItem}
            variant={variant}
            icon
            handleCollapseMenuClick={handleCollapseMenuClick}
            parentIndex={parentIndex}
            openedCollapseMenuIndex={openedCollapseMenuIndex}
            sideBarState={isSidebarOpenState}
          />
        );
      }
    });
  }
}

function CustomMenuItem({
  item,
  variant,
  icon,
  handleCollapseMenuClick,
  parentIndex,
  openedCollapseMenuIndex,
  sideBarState
}) {
  // console.log("checking single or multi level####🤔", item)
  const Component = item.__typename == 'PageType' ? SingleLevel : MultiLevel;
  // if (Component == SingleLevel) console.log("single item####⚠️🤓", item)

  return (
    <Component
      item={item}
      variant={variant}
      icon={icon}
      handleCollapseMenuClick={handleCollapseMenuClick}
      parentIndex={parentIndex}
      openedCollapseMenuIndex={openedCollapseMenuIndex}
      sideNavBarState={sideBarState}
    />
  );
}

function SingleLevel({ item, icon, sideNavBarState }) {
  // console.log("this is single level ⚠️", item)
  // if (item.parent && item.parent.level != 0) return null
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    setAnchorEl(null);
  }, [sideNavBarState]);

  // handle click function for menu popup
  const handleClick2 = (event) => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);

      setIsMenuOpen(true);
      setOpenModal(true);
    }
  };

  const handleClose = () => {
    const menuElement = document.querySelector('#basic-menu');
    if (menuElement) {
      if (!menuElement.querySelector('[role="menu"]').matches(':hover')) {
        setTimeout(() => {
          setAnchorEl(null);
        }, 100);
      }
    }
  };
  const handleCloseMenu = () => {
    setAnchorEl(false);
  };

  return (
    <StyledRouterLink to={item.sidebarUrl}>
      <ListItemButton
        className='customListItem'
        selected={location.pathname.includes(item.sidebarUrl)}
        onMouseEnter={item.title.toLowerCase() === 'home' ? handleClick2 : ''}
        onMouseLeave={() => {
          handleClose();
        }}
      >
        <StyledListItemIcon iconVisible={icon}>
          {GenerateIcon(item.icon)}
        </StyledListItemIcon>
        <ListItemText sx={{ display: 'block' }}>
          <Tooltip title={item.title}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'pointer'
              }}
            >
              {item.title}
            </div>
          </Tooltip>
        </ListItemText>
        {!sideNavBarState && Boolean(anchorEl) && (
          <Menu
            hideBackdrop
            id='basic-menu'
            className='customMenu'
            style={{
              left: '35px',
              top: '12px',
              display: anchorEl ? 'block' : 'none'
            }}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            MenuListProps={{
              onMouseLeave: handleClose
            }}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            sx={{ padding: '4px 0 4px 0' }}
            onClick={(event) => {
              if (event.currentTarget.id !== 'menu-content') {
                event.stopPropagation();
                handleCloseMenu();
              }
            }}
          >
            <button
              id='menu-content'
              className='menu-content'
              onClick={(event) => {
                console.log('event: ', event.target);
                event.stopPropagation();
              }}
            >
              {item && item.pages ? (
                item.pages.length > 0 ? (
                  <>
                    <div className='parent-text'>{item.title}</div>
                    {item.pages.map((page) => (
                      <div key={page.id}>
                        <button
                          className='child-text'
                          onClick={(event) => {
                            console.log('event: ', event.target);
                            navigate(page.sidebarUrl);
                            event.stopPropagation();
                            handleCloseMenu();
                          }}
                        >
                          {page.title ? page.title : '-'}
                        </button>
                      </div>
                    ))}
                  </>
                ) : item.children.length > 0 ? (
                  <>
                    <div className='parent-text'>{item.title}</div>
                    {item.children.map((e1) => (
                      <div key={e1.id}>
                        <div className='parent-text'>{e1.title}</div>
                        {e1.pages.map((e2) => (
                          <div key={e2.id}>
                            <button
                              className='child-text'
                              onClick={(event) => {
                                console.log('event: ', event.target);
                                navigate(e2.sidebarUrl);
                                event.stopPropagation();
                                handleCloseMenu();
                              }}
                            >
                              {e2.title ? e2.title : '-'}
                            </button>
                          </div>
                        ))}
                      </div>
                    ))}
                  </>
                ) : (
                  <div>{item.title}</div>
                )
              ) : (
                <div>
                  <button
                    className='child-text'
                    style={{
                      margin: '0px',
                      fontWeight: '600',
                      padding: '0px'
                    }}
                    onClick={(event) => {
                      console.log('event: ', event.target);
                      navigate(item.sidebarUrl);
                      event.stopPropagation();
                      handleCloseMenu();
                    }}
                  >
                    {item.title ? item.title : '-'}
                  </button>
                </div>
              )}
            </button>
          </Menu>
        )}
      </ListItemButton>
    </StyledRouterLink>
  );
  // }
}

function MultiLevel({
  item,
  icon,
  handleCollapseMenuClick,
  parentIndex,
  openedCollapseMenuIndex,
  sideNavBarState
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  useEffect(() => {
    setAnchorEl(null);
  }, [sideNavBarState]);

  // handle click function for menu popup
  const handleClick2 = (event) => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);

      setIsMenuOpen(true);
      setOpenModal(true);
    }
  };

  const handleClose = () => {
    const menuElement = document.querySelector('#basic-menu');
    if (menuElement) {
      if (!menuElement.querySelector('[role="menu"]').matches(':hover')) {
        setTimeout(() => {
          setAnchorEl(null);
        }, 100);
      }
    }
  };
  const handleCloseMenu = () => {
    setAnchorEl(false);
  };
  // console.log("this is multi level 🚩", item)
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const handleClick = () => {
    setOpen((prev) => !prev);
    if (item.pages && item.pages.length) {
      navigate(item.pages[0].sidebarUrl, { replace: true });
    }
    if (item.level === 2 || item.level === 1) {
      handleCollapseMenuClick(parentIndex);
    }
  };
  const [currIndex, setCurrIndex] = useState(null);

  if (item.__typename == 'PageCategoryType') {
    // console.log("this is 👶", item)
    return (
      <div
        style={
          urlMap(item.slug) && (item.level === 2 || item.level === 1)
            ? { background: '#00000014' }
            : { background: 'transparent' }
        }
      >
        <ListItemButton
          onClick={handleClick}
          className='customListItem'
          onMouseEnter={item.level === 2 ? handleClick2 : ''}
          onMouseLeave={() => {
            handleClose();
          }}
          style={
            item.level == 3
              ? { borderBottom: '1px solid #E8E8E8' }
              : { borderBottom: 'none', margin: 'none' }
          }
        >
          {/* {icon == true ? <StyledListItemIcon>
                          {GenerateIcon(item.icon && item.icon !== null ? item.icon : null)}
                      </StyledListItemIcon> : <StyledListItemIcon></StyledListItemIcon>} */}
          <StyledListItemIcon iconVisible={icon}>
            {GenerateIcon(item.icon && item.icon !== null ? item.icon : null)}
          </StyledListItemIcon>
          {/* <ListItemText primary={item?.title || "Title missing"} sx={{ textOverflow: 'ellipsis' }} /> */}
          <ListItemText sx={{ display: 'block' }}>
            <Tooltip title={item?.title || ''} arrow>
              <Typography noWrap>{item?.title || 'Title missing'}</Typography>
            </Tooltip>
          </ListItemText>

          {(item.pages && item.pages.length > 0) ||
          (item.children && item.children.length) > 0 ? (
            (
              item.level === 2 || item.level === 1
                ? parentIndex === openedCollapseMenuIndex
                : open
            ) ? (
              <ExpandLessIcon />
            ) : (
              <ExpandMoreIcon />
            )
          ) : null}
          {!sideNavBarState && Boolean(anchorEl) && (
            <Menu
              hideBackdrop
              id='basic-menu'
              className='customMenu'
              style={{
                left: '35px',
                top: '12px',
                display: anchorEl ? 'block' : 'none'
              }}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              MenuListProps={{
                onMouseLeave: handleClose
              }}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              sx={{ padding: '4px 0 4px 0' }}
              onClick={(event) => {
                if (event.currentTarget.id !== 'menu-content') {
                  event.stopPropagation();
                  handleCloseMenu();
                }
              }}
            >
              <button
                id='menu-content'
                className='menu-content'
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                {item && item.pages ? (
                  item.pages.length > 0 ? (
                    <>
                      <div className='parent-text'>{item.title}</div>
                      {item.pages.map((page) => (
                        <div key={page.id}>
                          <button
                            className='child-text'
                            onClick={(event) => {
                              console.log('event: ', event.target);
                              navigate(page.sidebarUrl);
                              event.stopPropagation();
                              handleCloseMenu();
                            }}
                          >
                            {page.title ? page.title : '-'}
                          </button>
                        </div>
                      ))}
                    </>
                  ) : item.children.length > 0 ? (
                    <>
                      <div className='parent-text'>{item.title}</div>
                      {item.children.map((e1) => (
                        <div key={e1.id} style={{ marginLeft: '12px' }}>
                          <div className='parent-text'>{e1.title}</div>
                          {e1.pages.map((e2) => (
                            <div key={e2.id}>
                              <button
                                className='child-text'
                                onClick={(event) => {
                                  console.log('event: ', event.target);
                                  navigate(e2.sidebarUrl);
                                  event.stopPropagation();
                                  handleCloseMenu();
                                }}
                              >
                                {e2.title ? e2.title : '-'}
                              </button>
                            </div>
                          ))}
                        </div>
                      ))}
                    </>
                  ) : (
                    <div>{item.title}</div>
                  )
                ) : (
                  <div>
                    <button
                      className='child-text'
                      onClick={(event) => {
                        console.log('event: ', event.target);
                        navigate(item.sidebarUrl);
                        event.stopPropagation();
                        handleCloseMenu();
                      }}
                    >
                      {item.title ? item.title : '-'}
                    </button>
                    {}
                  </div>
                )}
              </button>
            </Menu>
          )}
        </ListItemButton>
        <Collapse
          in={
            item.level === 2 || item.level === 1
              ? parentIndex === openedCollapseMenuIndex
              : open
          }
          timeout='auto'
          unmountOnExit
          style={
            item.level == 2 ? { marginBottom: '10px' } : { marginBottom: '0px' }
          }
        >
          <StyledList component='div' disablePadding sx={CollapsibleStyle}>
            {item?.pages && item.pages.length > 0
              ? item?.pages.map((child, key) => (
                  // console.log("this is 📕 and 🔑", child, key)
                  <CustomMenuItem key={`${item.id}-${key}`} item={child} />
                ))
              : null}
            {item?.children && item.children.length > 0
              ? item?.children.map((child, key) => (
                  // console.log("this is 👶 and 🔑", child, key)
                  <CustomMenuItem key={`${item.id}-${key}`} item={child} />
                ))
              : null}
          </StyledList>
        </Collapse>
      </div>
    );
  }
}

export default CollapsibleMenu;
